"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTipContentProperty = exports.tipContentPropertyDefinition = void 0;
exports.tipContentPropertyDefinition = {
    view: {
        label: 'Tip',
        style: 'blockquote',
    },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'tip-content-text',
                'tip-content-author',
                'tip-content-link',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'tip-content',
};
const isTipContentProperty = (prop) => {
    return prop.name === exports.tipContentPropertyDefinition.name;
};
exports.isTipContentProperty = isTipContentProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGlwLWNvbnRlbnQucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy90aXAtY29udGVudC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLDRCQUE0QixHQUFHO0lBQzFDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxLQUFLO1FBQ1osS0FBSyxFQUFFLFlBQVk7S0FDcEI7SUFDRCxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxtQkFBbUI7WUFDekIsUUFBUSxFQUFFO2dCQUNSLGtCQUFrQjtnQkFDbEIsb0JBQW9CO2dCQUNwQixrQkFBa0I7YUFDbkI7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLG1CQUFtQjtJQUN6QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxhQUFhO0NBQ1ksQ0FBQTtBQUkxQixNQUFNLG9CQUFvQixHQUFHLENBQUMsSUFBa0IsRUFBOEIsRUFBRTtJQUNyRixPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssb0NBQTRCLENBQUMsSUFBSSxDQUFBO0FBQ3hELENBQUMsQ0FBQTtBQUZZLFFBQUEsb0JBQW9CLHdCQUVoQyJ9